(function () {
  function init(root) {
    if (!root || root.dataset.bsHeroInitialized === 'true') return;
    root.dataset.bsHeroInitialized = 'true';

    var layers = root.querySelector('.js-bs-hero-layers');
    if (layers) {
      var fired = false;
      var reveal = function () {
        if (fired) return;
        fired = true;
        void layers.offsetWidth;
        layers.classList.add('is-ready');
      };
      var pending = Array.prototype.slice.call(layers.querySelectorAll('img')).filter(function (img) {
        return !img.complete;
      });

      if (!pending.length) {
        window.requestAnimationFrame(reveal);
      } else {
        var done = 0;
        var tick = function () {
          done += 1;
          if (done >= pending.length) reveal();
        };
        pending.forEach(function (img) {
          img.addEventListener('load', tick, { once: true });
          img.addEventListener('error', tick, { once: true });
        });
        window.setTimeout(reveal, 2500);
      }
    }

    var player = root.querySelector('.bs-hero__audio-player');
    if (!player) return;

    var button = player.querySelector('.bs-hero__audio-toggle');
    var audio = player.querySelector('audio');
    var pauseIcon = player.querySelector('.bs-hero__pause-icon');
    var playIcon = player.querySelector('.bs-hero__play-icon');
    if (!button || !audio || !pauseIcon || !playIcon) return;

    button.addEventListener('click', function () {
      if (audio.paused) {
        audio.play().then(function () {
          pauseIcon.classList.remove('hidden');
          playIcon.classList.add('hidden');
          button.setAttribute('aria-pressed', 'true');
        }).catch(function () {});
      } else {
        audio.pause();
        pauseIcon.classList.add('hidden');
        playIcon.classList.remove('hidden');
        button.setAttribute('aria-pressed', 'false');
      }
    });

    audio.addEventListener('ended', function () {
      pauseIcon.classList.add('hidden');
      playIcon.classList.remove('hidden');
      button.setAttribute('aria-pressed', 'false');
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bs-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-bs-hero]'));
  });
})();
